import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';
import { feeLabel, CATERING_SERVICE_FEE_KEY } from '../content/feeProgram';

const getCommunityFaqQuestions = (cityName, siteTitle, vehicleType, serviceFee) => [
  {
    question: `How many food ${vehicleType}s do I need for an event or festival?`,
    answer: `It depends on the crowd size, event length, and whether ${vehicleType}s are the only food. Ask each ${vehicleType} how many people it can serve per hour, and book more than one to shorten lines and add variety. Large festivals usually run several.`
  },
  {
    question: `How much does it cost to hire food ${vehicleType}s for events or festivals in ${cityName}?`,
    answer: `It depends on the format. For festivals and markets where ${vehicleType}s sell directly to the crowd, terms are arranged with each ${vehicleType}; some pay you a fee or a percentage of sales. For paid catering booked through the site, your full total, including the ${serviceFee} and tax, is shown before you pay. Requesting quotes is free either way.`
  },
  {
    question: `Can I book multiple food ${vehicleType}s for one event or festival?`,
    answer: `Yes. Multiple ${vehicleType}s are common for larger events, mixed cuisines, or shorter service windows.`
  },
  {
    question: `Do food ${vehicleType}s handle permits, insurance, and health requirements for events?`,
    answer: `Requirements vary by venue and event. Each ${vehicleType} is responsible for its own health permit, business license, and insurance, and we ask vendors for those documents when they join. Event permits, venue approvals, and site logistics are usually yours to handle, so check with your city or venue early.`
  },
  {
    question: `What types of events are food ${vehicleType}s best suited for?`,
    answer: `Festivals, farmers markets, school events, fundraisers, street fairs, concerts, block parties, and store openings. What they have in common: a crowd, a flat place to park, and no kitchen.`
  },
  {
    question: `How far in advance should I book food ${vehicleType}s for an event or festival?`,
    answer: `Earlier is better for weekends, large events, and peak seasons. If your date is close, send the request anyway. Availability varies by ${vehicleType}.`
  }
];

function CommunityFaq() {
  const config = useContext(ConfigContext);
  const { city_name, site_title, vehicle_type } = config;
  const vehicleType = vehicle_type.toLowerCase();
  // The customer service-fee rate comes from the payload (E11), never a literal.
  const serviceFee = feeLabel(config, CATERING_SERVICE_FEE_KEY);

  const questions = getCommunityFaqQuestions(city_name, site_title, vehicleType, serviceFee);

  return (
    <Faq questions={questions} />
  );
}

export default CommunityFaq;
